// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__PACYl","header":"App_header__OhjNL","title":"App_title__iT0dA","titleLight":"App_titleLight__aEw7N","footer":"App_footer__UJmNn"};